import React from "react"
import styled from "styled-components"

import { Row } from "@zendeskgarden/react-grid"
import { MD } from "@zendeskgarden/react-typography"
import StatusIcon from "./StatusIcon"

const IconMargin = styled.div`
  margin-left: 15px
  margin-right: 5px
`

const LegendDiv = styled.div`
  margin-right: 10px
  margin-bottom: 15px}
`

const Legend = () => {
  return (
    <LegendDiv>
      <Row justifyContent="end">
        <IconMargin><StatusIcon status="normal"/></IconMargin><MD>No active incidents</MD>
        <IconMargin><StatusIcon status="degradation"/></IconMargin><MD>Service degradation</MD>
        <IconMargin><StatusIcon status="outage"/></IconMargin><MD>Service outage</MD>
      </Row>
    </LegendDiv>
  )
}
export default Legend
